import {
  CREDIT_CARDS_LOADING,
  CREDIT_CARDS_ERROR,
  CREDIT_CARDS_SUCCESS,
  NEW_CREDIT_CARD_SUCCESS,
  DELETE_CREDIT_CARD_SUCCESS,
  EDIT_CREDIT_CARD_SUCCESS,
  CREDIT_CARD_ITEM_SUCCESS,
  ACCOUNTS_LOADING,
  ACCOUNTS_ERROR,
  CREDIT_ACCOUNTS_SUCCESS,
  NEW_CREDIT_ACCOUNT_SUCCESS,
  DELETE_CREDIT_ACCOUNT_SUCCESS,
  EDIT_CREDIT_ACCOUNT_SUCCESS,
  REQUEST_CREDIT_ACCOUNT_ITEM_SUCCESS,
  INVESTMENT_ACCOUNTS_SUCCESS,
  NEW_INVESTMENT_ACCOUNT_SUCCESS,
  DELETE_INVESTMENT_ACCOUNT_SUCCESS,
  EDIT_INVESTMENT_ACCOUNT_SUCCESS,
  REQUEST_INVESTMENT_ACCOUNT_ITEM_SUCCESS,
  CRYPTOCURRENCY_ACCOUNTS_SUCCESS,
  NEW_CRYPTOCURRENCY_ACCOUNT_SUCCESS,
  DELETE_CRYPTOCURRENCY_ACCOUNT_SUCCESS,
  EDIT_CRYPTOCURRENCY_ACCOUNT_SUCCESS,
  REQUEST_CRYPTOCURRENCY_ACCOUNT_ITEM_SUCCESS,
  FOOD_AND_HOUSING_SUCCESS,
  FOOD_AND_HOUSING_LOADING,
  FOOD_AND_HOUSING_ERROR,
  TRANSPORTATION_AND_MEDICAL_SUCCESS,
  TRANSPORTATION_AND_MEDICAL_LOADING,
  TRANSPORTATION_AND_MEDICAL_ERROR,
  OTHER_LIVING_EXPENSES_SUCCESS,
  OTHER_LIVING_EXPENSES_LOADING,
  OTHER_LIVING_EXPENSES_ERROR,
  GET_ADDITIONAL_FILES_SUCCESS,
  POST_ADDITIONAL_FILES_SUCCESS,
  DELETE_FILES_SUCCESS,
  VEHICLE_CALCULATIONS_REQUEST_SUCCESS,
  TRANSPORT_CALCULATIONS_REQUEST_SUCCESS, MEDICAL_CALCULATIONS_REQUEST_SUCCESS,
} from '@/app/expenses/store/types';

export const mutations = {
  [CREDIT_CARDS_LOADING]: (state) => {
    state.creditCardsLoadingStatus = 'loading';
  },
  [CREDIT_CARDS_ERROR]: (state) => {
    state.creditCardsLoadingStatus = 'error';
  },
  [CREDIT_CARDS_SUCCESS]: (state, items) => {
    state.creditCardsLoadingStatus = 'success';
    state.creditCards = items;
  },
  [NEW_CREDIT_CARD_SUCCESS]: (state, resp) => {
    state.creditCardsLoadingStatus = 'success';
    const newCreditCard = JSON.parse(resp.config.data);
    newCreditCard.id = resp.data.id;
    state.creditCards.push(newCreditCard);
  },
  [DELETE_CREDIT_CARD_SUCCESS]: (state, id) => {
    state.creditCardsLoadingStatus = 'success';
    const index = state.creditCards.findIndex(card => card.id === id);
    state.creditCards.splice(index, 1);
  },
  [EDIT_CREDIT_CARD_SUCCESS]: (state, item) => {
    state.creditCardsLoadingStatus = 'success';
    const index = state.creditCards.findIndex(card => card.id === item.editedItemId);
    state.creditCards.splice(index, 1, item.newItem);
  },
  [CREDIT_CARD_ITEM_SUCCESS]: (state, data) => {
    state.creditCardsLoadingStatus = 'success';
    state.itemDetails = data.item;
    state.itemDetails.id = data.id;
  },
  [ACCOUNTS_LOADING]: (state) => {
    state.accountsLoadingStatus = 'loading';
  },
  [ACCOUNTS_ERROR]: (state) => {
    state.accountsLoadingStatus = 'error';
  },
  [CREDIT_ACCOUNTS_SUCCESS]: (state, items) => {
    state.accountsLoadingStatus = 'success';
    state.creditAccounts = items;
  },
  [NEW_CREDIT_ACCOUNT_SUCCESS]: (state, resp) => {
    state.accountsLoadingStatus = 'success';
    const newAccount = JSON.parse(resp.config.data);
    newAccount.id = resp.data.id;
    state.creditAccounts.push(newAccount);
  },
  [DELETE_CREDIT_ACCOUNT_SUCCESS]: (state, id) => {
    state.accountsLoadingStatus = 'success';
    const index = state.creditAccounts.findIndex(account => account.id === id);
    state.creditAccounts.splice(index, 1);
  },
  [EDIT_CREDIT_ACCOUNT_SUCCESS]: (state, item) => {
    state.accountsLoadingStatus = 'success';
    const index = state.creditAccounts
      .findIndex(account => account.id === item.editedItemId);
    state.creditAccounts.splice(index, 1, item.newItem);
  },
  [REQUEST_CREDIT_ACCOUNT_ITEM_SUCCESS]: (state, data) => {
    state.accountsLoadingStatus = 'success';
    state.itemDetails = data.item;
    state.itemDetails.id = data.id;
  },
  [INVESTMENT_ACCOUNTS_SUCCESS]: (state, items) => {
    state.accountsLoadingStatus = 'success';
    state.investmentAccounts = items;
  },
  [NEW_INVESTMENT_ACCOUNT_SUCCESS]: (state, resp) => {
    state.accountsLoadingStatus = 'success';
    const newAccount = JSON.parse(resp.config.data);
    newAccount.id = resp.data.id;
    state.investmentAccounts.push(newAccount);
  },
  [DELETE_INVESTMENT_ACCOUNT_SUCCESS]: (state, id) => {
    state.accountsLoadingStatus = 'success';
    const index = state.investmentAccounts.findIndex(account => account.id === id);
    state.investmentAccounts.splice(index, 1);
  },
  [EDIT_INVESTMENT_ACCOUNT_SUCCESS]: (state, item) => {
    state.accountsLoadingStatus = 'success';
    const index = state.investmentAccounts
      .findIndex(account => account.id === item.editedItemId);
    state.investmentAccounts.splice(index, 1, item.newItem);
  },
  [REQUEST_INVESTMENT_ACCOUNT_ITEM_SUCCESS]: (state, data) => {
    state.accountsLoadingStatus = 'success';
    state.itemDetails = data.item;
    state.itemDetails.id = data.id;
  },
  [CRYPTOCURRENCY_ACCOUNTS_SUCCESS]: (state, items) => {
    state.accountsLoadingStatus = 'success';
    state.cryptocurrencyAccounts = items;
  },
  [NEW_CRYPTOCURRENCY_ACCOUNT_SUCCESS]: (state, resp) => {
    state.accountsLoadingStatus = 'success';
    const newAccount = JSON.parse(resp.config.data);
    newAccount.id = resp.data.id;
    state.cryptocurrencyAccounts.push(newAccount);
  },
  [DELETE_CRYPTOCURRENCY_ACCOUNT_SUCCESS]: (state, id) => {
    state.accountsLoadingStatus = 'success';
    const index = state.cryptocurrencyAccounts.findIndex(account => account.id === id);
    state.cryptocurrencyAccounts.splice(index, 1);
  },
  [EDIT_CRYPTOCURRENCY_ACCOUNT_SUCCESS]: (state, item) => {
    state.accountsLoadingStatus = 'success';
    const index = state.cryptocurrencyAccounts
      .findIndex(account => account.id === item.editedItemId);
    state.cryptocurrencyAccounts.splice(index, 1, item.newItem);
  },
  [REQUEST_CRYPTOCURRENCY_ACCOUNT_ITEM_SUCCESS]: (state, data) => {
    state.accountsLoadingStatus = 'success';
    state.itemDetails = data.item;
    state.itemDetails.id = data.id;
  },
  [FOOD_AND_HOUSING_SUCCESS]: (state, item) => {
    state.foodAndHousingLoadingStatus = 'success';
    state.foodAndHousing = item;
  },
  [FOOD_AND_HOUSING_LOADING]: (state) => {
    state.foodAndHousingLoadingStatus = 'loading';
  },
  [FOOD_AND_HOUSING_ERROR]: (state) => {
    state.foodAndHousingLoadingStatus = 'error';
  },
  [TRANSPORTATION_AND_MEDICAL_SUCCESS]: (state, item) => {
    state.transportationAndMedicalLoadingStatus = 'success';
    state.transportationAndMedical = item;
  },
  [TRANSPORTATION_AND_MEDICAL_LOADING]: (state) => {
    state.transportationAndMedicalLoadingStatus = 'loading';
  },
  [TRANSPORTATION_AND_MEDICAL_ERROR]: (state) => {
    state.transportationAndMedicalLoadingStatus = 'error';
  },
  [OTHER_LIVING_EXPENSES_SUCCESS]: (state, item) => {
    state.otherLivingExpensesLoadingStatus = 'success';
    state.otherLivingExpenses = item;
  },
  [OTHER_LIVING_EXPENSES_LOADING]: (state) => {
    state.otherLivingExpensesLoadingStatus = 'loading';
  },
  [OTHER_LIVING_EXPENSES_ERROR]: (state) => {
    state.otherLivingExpensesLoadingStatus = 'error';
  },
  [GET_ADDITIONAL_FILES_SUCCESS]: (state, resp) => {
    state.otherLivingExpensesLoadingStatus = 'success';
    state.additionalExpensesFiles = resp;
    resp.forEach((file, ind) => {
      state.additionalExpensesFiles[ind].name = file.filename;
    });
  },
  [POST_ADDITIONAL_FILES_SUCCESS]: (state, resp) => {
    state.otherLivingExpensesLoadingStatus = 'success';
    resp.forEach((file, index) => {
      const newFile = {
        ...resp[index],
        name: file.filename,
      };
      state.additionalExpensesFiles.push(newFile);
    });
  },
  [DELETE_FILES_SUCCESS]: (state, id) => {
    state.otherLivingExpensesLoadingStatus = 'success';
    const index = state.additionalExpensesFiles.findIndex(file => file.id === id);
    state.additionalExpensesFiles.splice(index, 1);
  },
  [VEHICLE_CALCULATIONS_REQUEST_SUCCESS]: (state, resp) => {
    state.transportationAndMedicalLoadingStatus = 'success';
    state.transportationAndMedical.vehicleOperating = resp;
  },
  [TRANSPORT_CALCULATIONS_REQUEST_SUCCESS]: (state, resp) => {
    state.transportationAndMedicalLoadingStatus = 'success';
    state.transportationAndMedical.publicTransportation = resp;
  },
  [MEDICAL_CALCULATIONS_REQUEST_SUCCESS]: (state, resp) => {
    state.transportationAndMedicalLoadingStatus = 'success';
    state.transportationAndMedical.outOfPocketHealthCare = resp;
  },
};
